<template>
  <div>
    <div class="mb-3 font-weight-bold">
      <i class="fas fa-edit text-orange mr-2"></i>
      Agregar Inventario
    </div>
    <div :class="{ 'w-25': !isMobile }">
      <div class="color-secondary-6 font-14 mb-1">
        Cantidad de Accesorio a Agregar:
      </div>
      <validation-observer :ref="`aui-${detailId}-observer`">
        <validation-provider
          v-slot="{ errors, failedRules }"
          rules="required|greaterThanZero"
        >
          <custom-input
            v-model="quantity"
            type="number"
            field="Cantidad"
            :custom-error-msg="
              failedRules.required ? 'Este campo es requerido.' : errors[0]
            "
            :error="errors[0]"
            @keypress.enter.native="save"
          />
        </validation-provider>
      </validation-observer>
    </div>

    <div
      class="d-flex justify-content-end mt-3 "
      :class="{ 'flex-column': isMobile }"
    >
      <action-button
        :variant="isMobile ? 'outline-danger mb-2' : 'outline-danger mr-2'"
        type="button"
        i="fas fa-times-circle"
        @click="cancel"
      >
        Cancelar
      </action-button>
      <action-button
        variant="success"
        type="button"
        i="fas fa-save"
        @click="save"
      >
        Guardar
      </action-button>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import mixAlert from '@/mixins/alert.mixin';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';

import service from '@/services/api/inventorycatalog.api';

export default {
  name: 'AccessoryUpdateInventory',
  mixins: [mixAlert],
  components: {
    CustomInput,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    detailId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    quantity: null,
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    validator() {
      return this.$refs[`aui-${this.detailId}-observer`];
    },
  },
  methods: {
    async cancel() {
      this.quantity = null;
      await this.validator.reset();
      this.$emit('cancel');
    },
    async save() {
      const valid = await this.validator.validate();
      if (!valid) return;
      try {
        await service.addAccessoryQuantity(this.detailId, this.quantity);
        this.ShowToast('', 'Datos guardados exitosamente.', 'success');
      } catch (error) {
        this.ShowToast('Alerta', error?.response?.data.message, 'error');
      }
      this.$emit('done');
    },
  },
};
</script>

<style lang="scss"></style>
